module.exports = __webpack_public_path__ + "static/img/0003.cf5315c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/0003.png
// module id = 9WAQ
// module chunks = 1